import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive.js';

const SkeletonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  margin-top: 24px;
`;

const ContentRow = styled.div`
  display: flex;
  width: 100%;
  gap: 48px;
  justify-content: center;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
`;

const CardCell = styled.div`
  width: 100%;
  max-width: 400px; /* keep cap on desktop */
  @media ${PHONE_MEDIA_QUERY} {
    max-width: none; /* full width on mobile */
  }
`;

const SkeletonBox = styled.div`
  width: 100%;
  aspect-ratio: 400 / 373; /* keep the same ratio as your viewBox */
`;

const CardSkeleton = () => {
  const theme = useTheme();
  return (
    <SkeletonBox>
      <ContentLoader
        speed={2}
        viewBox='0 0 400 373'
        backgroundColor={theme.background.secondary}
        foregroundColor={theme.special.skeleton}
        width='100%'
        height='100%'
        style={{ display: 'block' }}
      >
        <rect x='0' y='0' rx='16' ry='16' width='400' height='373' />
      </ContentLoader>
    </SkeletonBox>
  );
};

const GiftsListSkeleton = () => {
  return (
    <SkeletonContainer>
      <CardCell>
        <CardSkeleton />
      </CardCell>
      <CardCell>
        <CardSkeleton />
      </CardCell>
      <CardCell>
        <CardSkeleton />
      </CardCell>
    </SkeletonContainer>
  );
};

export default GiftsListSkeleton;
